<template>
    <fragment>
        <!-- Filters -->
        <filter-sidebar v-if="filters" v-bind:filters="filters"></filter-sidebar>

        <div class="global-container">
            <section class="section bg-white resource-container">
                <div class="row">
                    <div class="col-lg-12" v-if="listing.length > 0">
                        <ul class="testimonial-info col-md-12">
                            <resource-item v-for="(item, index) in listing"
                                           v-bind:item="item"
                                           v-bind:key="item.DetailID"></resource-item>

                        </ul>
                        <section class="section bg-white" v-if="listing.length > 0 && pagination.totalPages > 1">
                            <div class="row">
                                <div class="col-12">
                                    <pagination></pagination>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="col-lg-12 align-center" v-if="listing.length === 0">
                        <h2 class="not-found-heading">Sorry, no resources were found matching your specifications.</h2>
                        <p>
                            Try removing some filters or searching a different term.
                        </p>
                    </div>
                </div>
            </section>
        </div>

    </fragment>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import Pagination from '../components/listing/pagination-dropdown';
    import ResourceItem from '../components/listing/resource-item';
    import FilterSidebar from '../components/listing/resource-filter-sidebar';
    import resourceFilter from '../filters/resource-filter';
    import DiseaseFilter from '../filters/resource-disease-filter';
    import SearchFilter from '../filters/resource-search-filter';
    import TopicFilter from '../filters/resource-topic-filter';
    import TypeFilter from '../filters/resource-type-filter';
    import TypeSearchFilter from '../filters/resource-typesearch-filter';
    

    export default {
        props: ['filterid', 'filtertype', 'result', 'resource'],
        data: function () {
            return {
                filters: null,
            }
        },
        computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
        }),
        components: {
			pagination: Pagination,
            'resource-item': ResourceItem,
			'filter-sidebar': FilterSidebar,
        },
        mounted: function () {
            console.log(this.result);
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);
			this.setResource(this.resource);

			// import correct filters for this view based on prop value
            if (this.filtertype == "all") {
                this.filters = resourceFilter;
            } else if (this.filtertype == "disease") {
                this.filters = DiseaseFilter;
            } else if (this.filtertype == "topic") {
                this.filters = TopicFilter;
            } else if (this.filtertype == "type-search") {
                this.filters = TypeSearchFilter;
            } else if (this.filtertype == "type") {
                this.filters = TypeFilter;
            } else if (this.filtertype == "keyword") {
                this.filters = SearchFilter;
            }

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.resource-listing').offset().top
					}, 1000);
				}
			})

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
        },
    }
</script>